import { render, staticRenderFns } from "./ReadStatusButton.vue?vue&type=template&id=7dcf2ac6&scoped=true&"
import script from "./ReadStatusButton.vue?vue&type=script&lang=js&"
export * from "./ReadStatusButton.vue?vue&type=script&lang=js&"
import style0 from "./ReadStatusButton.vue?vue&type=style&index=0&id=7dcf2ac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcf2ac6",
  null
  
)

export default component.exports